export default "__VITE_ASSET__DBZxboWw__"